<div class="row">
  <div class="col-lg-6 col-md-12 offset-lg-3 mt-3 mr-3">
    <div class="card">
      <div class="card-status-top bg-success"></div>
      <div class="card-body">
        <h3 class="card-title">Teklifiniz başarıyla kaydedildi.</h3>
        <p>
          Teklifiniz değerlendirildikten tarafınıza dönüş yapılacaktır.
        </p>
        <p>
          İlginize teşekkür ederiz.
        </p>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <strong>VİŞNE MADENCİLİK ÜRETİM SANAYİ VE TİCARET A.Ş.</strong>
        </div>
      </div>
    </div>
  </div>
</div>